import { render, staticRenderFns } from "./period-select.vue?vue&type=template&id=3db9c781&"
import script from "./period-select.vue?vue&type=script&lang=js&"
export * from "./period-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports